module.exports = __webpack_public_path__ + "img/img12.c87d35d9.png";